import styled from '@emotion/styled'

export const ExpertBalanceSheetTableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: var(--lumen-padding-24);
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow-x: auto;
  overflow-y: hidden;

  > div {
    min-height: 0;
    max-height: 100%;
  }
`
